module.exports = __webpack_public_path__ + "static/media/wolffox5.2014dcf0.jpg";